import { ExternalLink } from "lucide-react";

export const NIBIRU_BRIDGE_URL = "https://app.nibiru.fi/bridge";

export default function NibiruBridgePanel() {
  return (
    <div className="flex flex-col items-center justify-center gap-4 px-8 py-10 text-center">
      <p className="text-[13px] text-[#666]">
        Opens the official Nibiru Bridge in a new tab.
      </p>
      <a
        href={NIBIRU_BRIDGE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-2 bg-gradient-to-b from-[#5b1deec0] to-[#5b1dee] text-white text-[14px] font-semibold rounded-[12px] px-6 py-3 hover:opacity-90 transition-opacity"
      >
        Open Nibiru Bridge
        <ExternalLink size={16} />
      </a>
    </div>
  );
}
